<div class="chart-box">
  <div class="landscape-view">
    <h4 class="text-center font-bold">{{ demand.name }}</h4>
    <div class="row">
      <div class="col-lg-6">
        <p-chart type="line" [data]="dataAktual" [options]="options" />
      </div>

      <div class="col-lg-6">
        <p-chart
          type="bar"
          [data]="arrivalsAndDepartures"
          [options]="options"
        />
      </div>
    </div>
  </div>

  <div class="portrait-view">
    <i class="pi pi-refresh mb-2" style="font-size: 3rem; color: #000000"></i>
    <p>Otočte zařízení na šířku</p>
  </div>
</div>
